import React, { useEffect, useLayoutEffect } from 'react';
import ContourPortrait from './components/ContourPortrait';
import InfoTextBlock from './components/InfoTextBlock';
import DimensionalBrush from './components/DimensionalBrush';
import { Container, Row, Col } from 'react-grid-system';
import { connect } from "react-redux";
import setCoverPresent, { setLightNav } from './redux/actions';
import './App.css';

function InfoPage({dispatch}) {
  useLayoutEffect(() => {
    document.documentElement.style.backgroundColor = '#000';
    document.body.style.backgroundColor = '#000';
    return () => {
      document.documentElement.style.backgroundColor = '';
      document.body.style.backgroundColor = '';
    };
  }, []);

  useEffect(() => {
    dispatch(setCoverPresent('no'));
    dispatch(setLightNav('#000000'));
    return () => {};
  }, []);

  return (

<div className="info-page">
	<DimensionalBrush />
	<div className="inner-wrapper">
	    <Container fluid className="page-pad">

		<Row>
    		<Col sm={3}>
    		<div className="project-headline">
    		Maria Chimishkyan is an art director, designer, and image maker based in New York. Currently Brand Designer at Figma.
    		<br/>
    		<br/>
    		Previously at Apple, Meta, Google, Bulletin, RoAndCo Studio, MTV, and Urban Outfitters.
    		<br/>
    		<br/>
    		Available for freelance and collaborations. Case studies available upon request.
</div>
    		</Col>

			<Col sm={3}>
				<ContourPortrait src="img/info-page/MariaChimishkyan_1.jpg" cellSize={18} thresholds={[80, 175]} />
			</Col>

			<Col sm={3} className="info-col-clients">
			<div className="subhead-white" style={{paddingBottom:'0px'}}>Select Clients</div>

	    		<div className="info-textblock">
		    		<div className="body-text">
			    		Apple<br/>
			    		The Atlantic<br/>
					Bandcamp<br/>
					Bloomberg Businessweek<br/>
					Cash App<br/>
					Elsewhere<br/>
					Google<br/>
					Medium<br/>
					MTV<br/>
					The New York Times<br/>
					The New Yorker<br/>
					Nike<br/>
					Spotify<br/>
					The Verge<br/>
					Vice Magazine<br/>
					The Wall Street Journal<br/>
		    		</div>
		    		<div className="spacer"></div>
		    	</div>

			</Col>

			<Col sm={3}>

			<div className="subhead-white" style={{paddingBottom:'0px'}}>Contact</div>

	    		<div className="info-textblock">
		    		<div className="body-text" style={{paddingBottom:'20px'}}>
		    		hi@mariachimi.com
		    		</div>
	    		</div>

	    		<div className="subhead-white" style={{paddingBottom:'0px'}}>Disciplines</div>

	    		<div className="info-textblock">
		    		<div className="body-text">
		    		3D Graphics<br/>
		    		Art Direction<br/>
		    		Brand Design<br/>
		    		Illustration<br/>
		    		Motion Design<br/>
				Product Design<br/>
				Visual Design<br/>
		    		</div>
	    		</div>

			</Col>
		</Row>

	</Container>
	</div>
</div>

  )
}

export default connect()(InfoPage);
